import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import moment from 'moment';
import { toast } from 'react-toastify';
import { extrairMensagemErro } from '~/Utils/Helpers';
import { alterarValidadeLoteIsencaoCobranca } from '~/Services/Service';
import { schemaAlterarValidadeLote } from './schemas';

const amanha = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().split('T')[0];
};

const ModalEditarIsencao = ({ show, isencao, onHide, onSucesso }) => {
  if (!isencao) return null;

  const validadeInicial = isencao.validade
    ? moment(isencao.validade).format('YYYY-MM-DD')
    : '';

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await alterarValidadeLoteIsencaoCobranca({
        itens: [
          {
            codigo_conta: isencao.codigo_conta,
            codigo_grupo_empresa: isencao.codigo_grupo_empresa,
          },
        ],
        nova_validade: values.nova_validade,
        motivo: values.motivo.trim(),
      });
      toast.success('Isenção atualizada com sucesso');
      onSucesso();
    } catch (err) {
      toast.error(extrairMensagemErro(err));
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Formik
        initialValues={{
          nova_validade: validadeInicial,
          motivo: '',
        }}
        validationSchema={schemaAlterarValidadeLote}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit: fSubmit, isSubmitting }) => (
          <Form noValidate onSubmit={fSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Editar Isenção</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col xs={12} className="mb-3">
                  <Form.Label className="small mb-1">Conta</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={`${isencao.codigo_conta} - ${isencao.apelido_conta || ''}`.trim()}
                    disabled
                    readOnly
                  />
                </Col>
                <Col xs={12} className="mb-3">
                  <Form.Label className="small mb-1">Empreendimento (GE)</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={isencao.codigo_grupo_empresa}
                    disabled
                    readOnly
                  />
                </Col>
                <Col xs={12} className="mb-3">
                  <Form.Label className="small mb-1">Nova Validade *</Form.Label>
                  <Form.Control
                    type="date"
                    name="nova_validade"
                    size="sm"
                    value={values.nova_validade}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.nova_validade && !!errors.nova_validade}
                    min={amanha()}
                  />
                  <Form.Control.Feedback type="invalid">{errors.nova_validade}</Form.Control.Feedback>
                </Col>
                <Col xs={12} className="mb-3">
                  <Form.Label className="small mb-1">Motivo *</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="motivo"
                    size="sm"
                    value={values.motivo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.motivo && !!errors.motivo}
                    maxLength={200}
                    placeholder="Informe o motivo da alteração"
                  />
                  <Form.Control.Feedback type="invalid">{errors.motivo}</Form.Control.Feedback>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" size="sm" onClick={onHide} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button variant="primary" size="sm" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Aguarde...' : 'Salvar'}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalEditarIsencao;
